<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      h1 My Account
      AccountSection.my-profile.mt-4(message="MY PROFILE")
        .row
          .col
            div
              strong User Name:
              |  {{ username }}
            div
              strong First Name:
              |  {{ firstName }}
            div
              strong Middle Name:
              |  {{ middleName }}
            div
              strong Last Name:
              |  {{ lastName }}
            div
              strong Title:
              |  {{ title }}
            div
              strong Primary Email Address:
              |  {{ email }}
            div
              strong Additional Email:
              |  {{ altEmail1 }}
            div
              strong Additional Email:
              |  {{ altEmail2 }}
            div
              strong Work Phone:
              |  {{ workPhone }}
            div
              strong Supervisor's First Name:
              |  {{ supervisorFirstName }}
            div
              strong Supervisor's Middle Name:
              |  {{ supervisorMiddleName }}
            div
              strong Supervisor's Last Name:
              |  {{ supervisorLastName }}
            div
              strong Supervisor's Rank:
              |  {{ supervisorRank }}
            div
              strong Supervisor's Email:
              |  {{ supervisorEmail }}
            div
              strong Supervisor's Phone:
              |  {{ supervisorPhone }}
          .col.text-right
            router-link.btn.btn-primary(to="edit_profile") Edit Profile
      AccountSection.password.mt-4(message="PASSWORD")
        .row
          .col
            div
              strong Password:
              |  *******
          .col.text-right
            router-link.btn.btn-primary(to="change_password") Change Password
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import AccountSection from '@/components/AccountSection'
export default {
  name: 'MyAccount',
  computed: {
    ...mapFields('account', [
      'username',
      'firstName',
      'lastName',
      'middleName',
      'title',
      'email',
      'altEmail1',
      'altEmail2',
      'workPhone',
      'supervisorFirstName',
      'supervisorMiddleName',
      'supervisorLastName',
      'supervisorRank',
      'supervisorEmail',
      'supervisorPhone'
    ]),
  },
  components: {
    AccountSection,
  },
}
</script>

<style lang="scss" scoped>
</style>
